import React, { useEffect, useState } from 'react';
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  PDFViewer,
  Font,
} from '@react-pdf/renderer';
import LatoItalicFont from '../../Fonts/Baloo2-VariableFont_wght.ttf';

// Register your font
Font.register({
  family: 'Lato-Italic',
  src: LatoItalicFont,
});

const Ratetableprint = () => {
  const [gridData2D, setGridData2D] = useState([]);

  useEffect(() => {
    // 1) load flat data from localStorage
    const flatJSON = localStorage.getItem('gridData');
    if (!flatJSON) return;
    const flat = JSON.parse(flatJSON);

    // 2) extract unique sorted fats & snfs
    const fats = Array.from(new Set(flat.map((o) => o.fat))).sort(
      (a, b) => parseFloat(a) - parseFloat(b)
    );
    const snfs = Array.from(new Set(flat.map((o) => o.snf))).sort(
      (a, b) => parseFloat(a) - parseFloat(b)
    );

    // 3) build 2D grid: one subarray per fat, columns in snf order
    const grid = fats.map((fat) =>
      snfs.map((snf) => {
        return (
          flat.find((o) => o.fat === fat && o.snf === snf) || {
            fat,
            snf,
            rate: '',
          }
        );
      })
    );

    setGridData2D(grid);
  }, []);

  return (
    <PDFViewer className="pdf">
      <Document>
        {gridData2D.length > 0 && (
          <Page size="A4" orientation="portrait" style={styles.page}>
            {/* Title */}
            <Text style={styles.latoText}>
              {localStorage.getItem('kendra')}
            </Text>
            <Text style={styles.latoText2}>{"दरपत्रक" + " - " + localStorage.getItem("ratechartype")}</Text>

            {/* Rate Chart Table */}
            <View style={styles.table}>
              {/* Header Row */}
              <View style={styles.tableRow}>
                <Text style={styles.firstColumn}>Fat/SNF</Text>
                {gridData2D[0].map((_, i) => (
                  <Text key={i} style={styles.headerCell}>
                    {gridData2D[0][i].snf}
                  </Text>
                ))}
              </View>

              {/* Data Rows */}
              {gridData2D.map((rowArr, rowIndex) => (
                <View key={rowIndex} style={styles.tableRow}>
                  {/* Fat label */}
                  <Text style={styles.firstColumn}>{rowArr[0].fat}</Text>
                  {/* Rate cells */}
                  {rowArr.map((cellObj, colIndex) => (
                    <Text key={colIndex} style={styles.cell}>
                      {cellObj.rate || '-'}
                    </Text>
                  ))}
                </View>
              ))}
            </View>
          </Page>
        )}
      </Document>
    </PDFViewer>
  );
};

const styles = StyleSheet.create({
  page: {
    paddingTop: 10,
    paddingBottom: 5,
    paddingHorizontal: 10,
  },
  latoText: {
    fontFamily: 'Lato-Italic',
    fontSize: 14,
    textAlign: 'center',
    fontWeight: 'bold',
    marginBottom: 4,
  },
  latoText2: {
    fontFamily: 'Lato-Italic',
    fontSize: 11,
    textAlign: 'center',
    fontWeight: 'bold',
    marginBottom: 6,
  },
  table: {
    display: 'table',
    width: '100%',
    borderWidth: 1,
    borderColor: '#000',
    borderStyle: 'solid',
    marginTop: 10,
  },
  tableRow: {
    flexDirection: 'row',
  },
  firstColumn: {
    width: 40,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: '#000',
    backgroundColor: '#eee',
    padding: 4,
    fontSize: 9,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  headerCell: {
    flex: 1,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: '#000',
    backgroundColor: '#eee',
    padding: 4,
    fontSize: 9,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  cell: {
    flex: 1,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: '#000',
    padding: 4,
    fontSize: 8,
    textAlign: 'center',
  },
});

export default Ratetableprint;
